import React, { useEffect, useMemo, useState } from 'react'
import { Modal } from 'semantic-ui-react'
import { GetTapechartDisplaySettings } from '../../api/services/pms'
import { useTextResources } from '../../language'
import GridPanel from '../../components/GridPanel'
import { onError, onWarning } from '../../components/shared/messages'
import PropTypes from 'prop-types'

export const CalendarDisplaySettings = ({HotelID})=>{
    const [settings, setSettings] = useState([])
    const text = useTextResources()

    useEffect(()=>{
        if (HotelID) {
            (async ()=>{
                try {
                    const settings = await GetTapechartDisplaySettings({
                        HotelID: HotelID,
                        IncludeMaintenanceStatusType: true,
                        IncludeReservationStatus: true
                    })
                    setSettings(settings)
                } catch (error) {
                    error.status === 400?onWarning(error):onError(error);
                }
            })()
        }
    }, [HotelID])

    const options = useMemo(() => {
        return {
            columns: [
                { name: 'Type', title: text("Type"), getCellValue: () => "Something" },
            ]
        }
    }, [])
    return <GridPanel data={settings} options={options}></GridPanel>
}

export const CalendarDisplaySettingsPopup = (props)=>{
    const text = useTextResources()
    return <Modal size="small" {...props}>
        <Modal.Header>{text("CalendarDisplaySettings")}</Modal.Header>
        <Modal.Content><CalendarDisplaySettings HotelID={props.HotelID}/></Modal.Content>
        <Modal.Actions></Modal.Actions>
    </Modal>
}

CalendarDisplaySettings.propTypes = {
    HotelID: PropTypes.number
}
CalendarDisplaySettingsPopup.propTypes = {
    HotelID: PropTypes.number
}